import React from 'react';
import { useParams } from 'react-router-dom';
import Chatgrup from './Chatgrup';

const ChatGroupWrapper = () => {
  const { groupId } = useParams();

  // Opcional: validación de grupo permitido, redirección, etc.

  return <Chatgrup groupId={groupId} />;
};

export default ChatGroupWrapper;
